import { render, staticRenderFns } from "./fidelior-title.vue?vue&type=template&id=23368194&"
import script from "./fidelior-title.vue?vue&type=script&lang=js&"
export * from "./fidelior-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports